import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/door-access/starter-kits/g3-starter-kit.png";
import type { Product } from "../../types";
import { starterKits } from "../product-list-groups/starterKits";
import {
  includedAccessories,
  includedHub,
  includedReaders,
  touchPassSupport,
} from "../properties";

export const g3StarterKit: Product = {
  id: "g3StarterKit",
  productTitle: "G3 Starter Kit",
  description: "g3StarterKit.description",
  productListGroup: starterKits,
  descriptionMaxWidth: 220,
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.DoorAccess}/ua-g3-sk`,
  ],
  storePathParts: {
    category: UniFiChildCategorySlug.DoorAccessStarterKit,
    productSlug: "ua-g3-sk",
  },
  image: { src: image, width: 200, height: 160 },
  isNew: true,
  propertyValues: [
    {
      propertyId: includedHub.id,
      value: {
        type: "translation",
        value: "g3StarterKit.includedHub",
      },
    },
    {
      propertyId: includedReaders.id,
      value: {
        type: "translation",
        value: "g3StarterKit.includedReaders",
      },
    },
    {
      propertyId: includedAccessories.id,
      value: {
        type: "translation",
        value: "g3StarterKit.includedAccessories",
      },
    },
    {
      propertyId: touchPassSupport.id,
      value: {
        type: "string",
        value: "Apple Wallet\nGoogle Wallet",
      },
    },
  ],
};
